/**
 * I dieci temi dell'interfaccia.
 *
 * Elenco chiuso, in un modulo che leggono sia il client sia le funzioni: il server valida
 * contro questo array e il selettore delle impostazioni si disegna dallo stesso, così
 * aggiungere un tema resta una modifica sola — qui e in `token.css`.
 *
 * Il tema cambia il solo accento: si sostituisce nei pulsanti, nei collegamenti, nelle
 * righe attive e nei numeri di campo; non tocca né la carta né i colori che dicono
 * qualcosa (successo, avviso, errore, provvisorio, libero).
 */

export const TEMI = [
  'verde',
  'ardesia',
  'seppia',
  'granata',
  'petrolio',
  'indaco',
  'ruggine',
  'oliva',
  'prugna',
  'grafite',
] as const;

export type Tema = (typeof TEMI)[number];

/** Quello di chi non ha ancora scelto, di chi non ha fatto l'accesso e di `:root`. */
export const TEMA_PREDEFINITO: Tema = 'verde';

export const NOME_TEMA: Record<Tema, string> = {
  verde: 'Verde',
  ardesia: 'Ardesia',
  seppia: 'Seppia',
  granata: 'Granata',
  petrolio: 'Petrolio',
  indaco: 'Indaco',
  ruggine: 'Ruggine',
  oliva: 'Oliva',
  prugna: 'Prugna',
  grafite: 'Grafite',
};

/** Il campione mostrato accanto al nome nel selettore: è il pieno di quel tema. */
export const CAMPIONE_TEMA: Record<Tema, string> = {
  verde: '#1f5136',
  ardesia: '#2b4257',
  seppia: '#6b4a1f',
  granata: '#7a1f3d',
  petrolio: '#10484f',
  indaco: '#35357a',
  ruggine: '#8a3b14',
  oliva: '#4a5320',
  prugna: '#4e2a5c',
  grafite: '#33322e',
};

/**
 * Riconosce un tema valido. Restituisce `null` su tutto il resto — compreso il caso di una
 * colonna che, per un vecchio record o una modifica a mano, contenga qualcosa che non è
 * più nell'elenco: chi chiama decide se rifiutare la richiesta o ripiegare sul predefinito.
 */
export function leggiTema(valore: unknown): Tema | null {
  return typeof valore === 'string' && (TEMI as readonly string[]).includes(valore)
    ? (valore as Tema)
    : null;
}
